import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "app-page"
};
import { remove } from '@/api/system/menu';
import { MENU_STYLE } from '@/constant/system/code';
import { deleteBox, toast } from '@/utils/message';
import { renderActionDialog } from './action';
import { renderAddForm } from './add';
import { renderEditForm } from './edit';
import { createTable } from './table';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  setup: function setup(__props) {
    var tableRef = ref();
    var addRef = ref();
    var editRef = ref();
    var menuActionRef = ref();
    var table = null;
    var addForm = null;
    var editForm = null;
    var menuAction = null;
    onMounted(function () {
      table = createTable(tableRef.value, {
        rowAdd: rowAdd,
        rowDelete: rowDelete,
        rowEdit: rowEdit,
        rowHandle: rowHandle
      }, {
        addFn: addFn,
        searchFn: searchFn
      });
      addForm = renderAddForm(addRef.value);
      editForm = renderEditForm(editRef.value);
      menuAction = renderActionDialog(menuActionRef.value);
      editForm.onSaveSuccess = function () {
        var _table;
        (_table = table) === null || _table === void 0 || _table.load();
      };
      addForm.onSaveSuccess = function () {
        var _table2;
        (_table2 = table) === null || _table2 === void 0 || _table2.load();
      };
      addForm.onOpend = function () {
        var _addForm;
        (_addForm = addForm) === null || _addForm === void 0 || _addForm.hideFormItemByKey('component');
      };
      table.load();
    });
    // 行操作
    function rowHandle(row) {
      var _menuAction;
      (_menuAction = menuAction) === null || _menuAction === void 0 || _menuAction.open({
        menuId: row.id
      });
    }
    function rowAdd(row) {
      var _addForm2;
      (_addForm2 = addForm) === null || _addForm2 === void 0 || _addForm2.open({
        parentId: row.id,
        sort: 0
      });
    }
    function rowEdit(row) {
      var _editForm;
      (_editForm = editForm) === null || _editForm === void 0 || _editForm.open(row.id).then(function () {
        if (row.menuStyle === MENU_STYLE.CATALOG) {
          var _editForm2;
          (_editForm2 = editForm) === null || _editForm2 === void 0 || _editForm2.hideFormItemByKey('component');
        } else {
          var _editForm3;
          (_editForm3 = editForm) === null || _editForm3 === void 0 || _editForm3.showFormItemByKey('component');
        }
      });
    }
    function rowDelete(row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          var _table3;
          toast.success('删除成功');
          (_table3 = table) === null || _table3 === void 0 || _table3.load();
        });
      });
    }
    function addFn() {
      var _addForm3;
      (_addForm3 = addForm) === null || _addForm3 === void 0 || _addForm3.open({
        sort: 0,
        menuStyle: MENU_STYLE.CATALOG
      });
    }
    function searchFn() {
      var _table4;
      (_table4 = table) === null || _table4 === void 0 || _table4.load();
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "table",
        style: {
          "height": "100%"
        },
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "addRef",
        ref: addRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "menuActionRef",
        ref: menuActionRef
      }, null, 512)]);
    };
  }
});